export const commandResult = (success, result, error) => ({
    success,
    result,
    error,
});

export const success = (result = '', error = '') =>
    commandResult(true, result ?? '', error ?? '');

export const failure = (error = '', result = '') =>
    commandResult(false, result ?? '', error ?? '');
